import $ from 'jquery';

export default class EMailService {
    constructor() {}

    post(url, body, successCallback, errorCallback) {

        const jsonBody = JSON.stringify(body);

        $.ajax({
            url: url,
            type: "POST",
            contentType: "application/json",
            contentLength: jsonBody.length,
            data: jsonBody,
            success: successCallback,
            error: errorCallback
        });
    }

    unregisterEMailAddress(base64EncryptedEmail, successCallback, errorCallback) {
        const body = {
            email: base64EncryptedEmail
        };
        this.post("/api/email", body, successCallback, errorCallback);
    }


    unregisterEfEMailAddress(base64EncryptedEmail, successCallback, errorCallback) {
        const body = {
            email: base64EncryptedEmail
        };
        this.post("/api/email/effectmeasure", body, successCallback, errorCallback);
    }
}